<template>
  <div class="section py-0 px-5">
    <div class="tile app-title">
      <p class="subtitle is-6">Par date</p>
    </div>
    <b-datepicker placeholder="Cliquer ici..."
                  icon="calendar-today"
                  v-model="dateDeVisualisation"
                  :readonly="false"
                  :show-week-number="true"/>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import * as types from '@/store/creationOpportunite/venteReseauxLc-mutation-type';
import gestionErreur from '@/services/general/gestionErreur';

const VenteReseauxLc = createNamespacedHelpers('venteReseauxLc');

export default {
  name: 'date',
  data() {
    return {
    };
  },
  computed: {
    ...VenteReseauxLc.mapGetters({
      dateDeVisualisationReseauxLc: 'dateDeVisualisationReseauxLc',
    }),
    dateDeVisualisation: {
      get() {
        return this.dateDeVisualisationReseauxLc;
      },
      set(value) {
        this.setDateDeVisualisation(value);
        this.rechercheVentesReseaux();
      },
    },
  },
  methods: {
    ...VenteReseauxLc.mapMutations({
      setDateDeVisualisation: types.SET_DATE_DE_VISUALISATION,
    }),
    ...VenteReseauxLc.mapActions({
      actionsRechercheReseauxLc: 'rechercheReseauxLc',
    }),
    rechercheVentesReseaux() {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      this.actionsRechercheReseauxLc().then(() => {
        loadingComponent.close();
      }).catch((e) => {
        loadingComponent.close();
        gestionErreur('Erreur lors de la recherche des réseaux LC liée au filtre date', e);
      });
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteReseauxLc/filtres/date.vue